// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@sc/App/SharedStyles/CartLineSharedStyles";
import { FormFieldStyle } from "@sc/MobiusOverrides/FormField";
import { staticListProductListLineStyles } from "@sc/Overrides/Widgets/StaticList/StaticListProductListLine";
import { mergeWithCss } from "@sc/XDL/Utilities";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

staticListProductListLineStyles.container = {
    css: css`
        display: flex;
        padding: 20px 0;
        gap: 20px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

staticListProductListLineStyles.imageWrapper = {
    css: css`
        margin-right: 20px;
        background-color: ${color("common.white")};
        width: 90px;
        height: 90px;
        ${xScreen("lt", "xs")} {
            width: 280px;
            height: 280px;
            margin: 0 auto 12px;
        }
        @media print {
            width: 100px;
            height: 100px;
            margin-right: 16px;
            margin-left: 0;
        }
    `,
};

staticListProductListLineStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            width: 120px;
            height: 120px;
            justify-content: center;
            ${xScreen("lt", "xs")} {
                width: 100%;
                height: 100%;
                max-height: 280px;
            }
            @media print {
                width: 100px;
                height: 100px;
            }
        `,
    },
};

staticListProductListLineStyles.infoGridContainer = { gap: 12 };

staticListProductListLineStyles.descriptionGridItem = {
    width: [12, 11, 12, 5, 5],
    css: css`
        flex-direction: column;
        margin-right: auto;
        gap: 10px;
        ${xScreen("lte", "sm")} {
            margin-bottom: 10px;
        }
    `,
};

staticListProductListLineStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

staticListProductListLineStyles.productPartNumbersStyles = {
    ...cartLineSharedStyles.productPartNumbers,
};

staticListProductListLineStyles.actionsGridItem = {
    width: [12, 11, 12, 7, 7],
};

staticListProductListLineStyles.actionsGridContainer = {
    gap: 12,
};

staticListProductListLineStyles.availabilityAndNotesGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
        gap: 10px;
    `,
};

staticListProductListLineStyles.productAvailabilityStyles = {
    ...cartLineSharedStyles.productAvailability,
};

staticListProductListLineStyles.priceAndActionsGridItem = {
    width: [12, 10, 6, 6, 6],
};

staticListProductListLineStyles.priceAndActionsInnerContainer = {
    gap: 12,
};

staticListProductListLineStyles.priceGridItem = {
    width: 12,
    printWidth: 5,
    css: css`
        flex-direction: column;
    `,
};

staticListProductListLineStyles.productPriceStyles = {
    ...mergeWithCss(cartLineSharedStyles.productPrice, {
        wrapper: {
            css: css`
                ${xScreen("lte", "md")} {
                    margin-bottom: 0;
                }
            `,
        },
    }),
};

staticListProductListLineStyles.uomGridItem = {
    width: 12,
    printWidth: 6,
    css: css`
        ${FormFieldStyle} {
            max-width: 90px;
            min-width: 90px;
        }
    `,
};

staticListProductListLineStyles.productUnitOfMeasureSelectStyles = {
    mergeCss: true,
    labelProps: {
        css: css`
            @media print {
                font-size: 12px;
            }
        `,
    },
    iconProps: {
        size: 13,
        css: css`
            @media print {
                display: none;
            }
            &&&& {
                display: flex;
                justify-content: flex-end;
                padding-right: 13px;
                width: auto;
                height: 23px;
            }
            svg {
                width: 8px;
                height: 13px;
            }
        `,
    },
    css: css`
        &&&& {
            height: 26px;
        }
    `,
};

staticListProductListLineStyles.quantityAddToCartGridItem = {
    width: 12,
    css: css`
        gap: 15px;
        & > div:first-child {
            min-width: 90px;
            max-width: 90px;
        }
        ${xScreen("lte", "xs")} {
            flex-wrap: wrap;
        }
    `,
};

staticListProductListLineStyles.addToCartButton = {
    css: css`
        width: 100%;
        // min-height: 26px;
        white-space: nowrap;
    `,
};

staticListProductListLineStyles.addToListGridItem = {
    width: 12,
};

staticListProductListLineStyles.addToListLink = {
    link: {
        ...cartLineSharedStyles.addToListLink,
    },
};
